import React from 'react';
import { InputAdornment } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { FormErrorUI, FormLabelUI, InputUI } from '../Interface';

const ItemStockPlanningTab = ({ viewField, autoCompleteData, selectedValues }) => {
  const { values, errors } = useFormikContext();
  const quantityUnitName =
    autoCompleteData?.quantityUnit?.find((unit) => unit.id === values.quantityUnitId)?.name ??
    (selectedValues?.quantityUnitId === values.quantityUnitId ? selectedValues?.quantityUnit?.name : '') ??
    '';

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mx-4 mb-5">
      {[
        { name: 'minimumStock', label: 'Minimum készlet', unit: quantityUnitName, step: '0.000001' },
        { name: 'maximumStock', label: 'Maximum készlet', unit: quantityUnitName, step: '0.000001' },
        { name: 'replenishmentDays', label: 'Utánpótlási idő', unit: 'nap', step: '1' },
      ].map(({ name, label, unit, step }) => (
        <Field
          key={name}
          name={name}
          type="number"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text={label} />}
          variant="standard"
          value={values[name] ?? ''}
          helperText={<FormErrorUI message={errors[name]} />}
          disabled={viewField}
          inputProps={{ min: 0, step }}
          InputProps={{ endAdornment: unit ? <InputAdornment position="end">{unit}</InputAdornment> : null }}
          InputLabelProps={{ shrink: true }}
        />
      ))}
    </div>
  );
};

export default ItemStockPlanningTab;
